/*Junais  02-04-2022*/

import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../actions/secmasteractions';
import { checkAccess } from '../../../actions/securityactions';
import { getUserBranch } from '../../dashboard/actions/dashboardactions';

export default function UserGroups() {
    const state = useSelector(state => state.secmasterReducer);
    const dispatch = useDispatch();

    var checkPermissions = state.checkPermissions;

    var groupsMaster = state.userGroups.groupsMasters;
    var userGroups = state.userGroups.userGroups;
    const refUserGroups = useRef(null);

    console.log("groupsMaster", groupsMaster);
    console.log("userGroups", userGroups);
    useEffect(() => {
        async function checkPermissions() {
            //await dispatch(checkAccess({ pageMenuId: 1 }));
        }
        checkPermissions()
        scrollToBottom();
        /*  async function getUserGroups() {
             await dispatch(actions.getUserGroups());
         }
         getUserGroups(); */
    }, []);
    const scrollToBottom = () => {
        refUserGroups.current?.scrollIntoView({ behavior: 'smooth' });
    };
    /* function onRequestClose() {
        dispatch(actions.closeReport());
    } */

    function handleAllGroupsRadioBtnChange(value, e) {
        dispatch(actions.handleAllGroupsRadioBtnChange(value, e.target.checked))
    }
    function handleUserGroupsRadioBtnChange(value, e) {
        dispatch(actions.handleUserGroupsRadioBtnChange(value, e.target.checked))
    }

    /* function handleCheckBoxChange(reportId, value) {
        dispatch(actions.handleCheckBoxChange(reportId, value));
        async function getReportParams() {
            await dispatch(actions.getReportParams(reportId, state.reportOptions.uiParams));
        }
        getReportParams();
    }*/
    function resetUserGroups() {
        dispatch(actions.resetUserGroups())
    }
    function moveToUserGroups() {
        dispatch(actions.moveToUserGroups())
    }
    function removeFromUserGroups() {
        dispatch(actions.removeFromUserGroups())
    }

    function saveUserGroups() {
        dispatch(actions.saveUserGroups())
    }
    function renderSystemsGroups() {
        if (groupsMaster.length == 1 && groupsMaster[0].groupId == 0) {
            return <></>
        }
        return (
            <>
                {groupsMaster.length > 0 && groupsMaster.map((groupsMaster, index) => (
                    <div className="mb-12 col-md-12" key={groupsMaster.groupId}>
                        <div className="form-check form-check-inline">
                            <input type="radio" id={`customRadio_group${groupsMaster.groupId}`}
                                name={`customRadio_group${groupsMaster.groupId}`} className="form-check-input"
                                onChange={(e) => handleAllGroupsRadioBtnChange(groupsMaster.groupId, e)}
                                checked={groupsMaster.isChecked}
                                disabled={userGroups.map(ub => ub.groupId).filter(br => br == groupsMaster.groupId).length > 0} />
                            <label className="form-check-label" htmlFor={`customRadio_group${groupsMaster.groupId}`}>{groupsMaster.groupName}</label>
                        </div>
                    </div>
                ))}
            </>
        )
    }


    function renderSelectedGroups() {
        if (userGroups.length == 0) {
            return <><div className="row g-2">
                <div className="mb-1 col-md-12">
                    {<h5 className="alert alert-danger">No groups assigned...</h5>}
                </div>
            </div></>
        }
        return (
            <>
                {userGroups.length > 0 && userGroups.map((userBranch, index) => (
                    <div className="mb-12 col-md-12" key={userBranch.groupId}>
                        <div className="form-check form-check-inline">
                            <input type="radio" id={`customRadio_user${userBranch.groupId}`}
                                name={`customRadio_user${userBranch.groupId}`} className="form-check-input"
                                onChange={(e) => handleUserGroupsRadioBtnChange(userBranch.groupId, e)}
                                checked={userBranch.isChecked} />
                            <label className="form-check-label" htmlFor={`customRadio_user${userBranch.groupId}`}>{userBranch.groupName}</label>
                        </div>
                    </div>
                ))}
            </>
        )
    }
    return (
        <>
            <div className="content" ref={refUserGroups}>
                <div className="row">
                    <div className="col-6">
                        <div className="card ribbon-box">
                            <div className="card-body">
                                <div className="ribbon ribbon-primary float-start"><i className="dripicons-list me-1"></i>Applicable Groups</div>

                                <div class="custmcontainer">
                                    <div class="left-section">
                                        <h5>
                                            {/* <i class="dripicons-view-list"></i> */} All Groups
                                        </h5>
                                        <hr />
                                        <div className="row g-2">
                                            {renderSystemsGroups()}

                                        </div>
                                    </div>

                                    <div /* style={{ innerWidth: "2px" }} */ className='ms-5 col-md-6 mt-5 pt-5'>
                                        {checkPermissions.hasAddUserGroup && <button className='btn btn-primary mb-1 mt-5' type="button" disabled={groupsMaster.filter(b => b.isChecked == true).length == 0}
                                            onClick={() => moveToUserGroups()}><i class="dripicons-chevron-right " /> </button>
                                        }
                                        <div className="mb-1" />
                                        {checkPermissions.hasRemoveUserGroup && <button className='btn btn-primary' type="button" disabled={userGroups.filter(b => b.isChecked == true).length == 0}
                                            onClick={() => removeFromUserGroups()}><i class="dripicons-chevron-left " /></button>
                                        }
                                    </div>

                                    <div class="right-section">
                                        <h5>
                                            {/* <i class="dripicons-view-list"></i> */} User Groups
                                        </h5>
                                        <hr />
                                        <div className="row g-2">
                                            {renderSelectedGroups()}
                                        </div>
                                    </div>
                                </div>
                                <div className="row g-2">
                                    <div class="modal-footer">

                                        {checkPermissions.hasResetUserGroup && <button className='btn btn-danger' type="button" onClick={() => resetUserGroups()}><i className="mdi mdi-rotate-left" /> Reset</button>}
                                        {checkPermissions.hasSaveUserGroup && <button className='btn btn-success' type="button" onClick={() => saveUserGroups()}><i class="dripicons-print"></i> Save</button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

